module.exports = __webpack_public_path__ + "static/media/Heebo-Light.f073bf57.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/avesco/Heebo-Light.woff
// module id = 780
// module chunks = 0